<template>
  <div class="acceptance order-info" id="orderlist">
    <div class="title-order">
      全部订单 /
      <span>验收</span>
    </div>
    <div class="goods-info">
      <div class="title-mode title-accept">商品信息</div>
      <div class="goods">
        <div class="goods-tab">
          <div class="shang">商品</div>
          <div class="shuliang">数量</div>
          <div class="baozhuang">包装方式</div>
        </div>
        <div class="goods-list">
          <div
            class="item-goods"
            v-for="(item, index) in orderInfo.orderItems"
            :key="index"
            v-if="index <= showNum"
          >
            <img :src="item.imgUrl" alt />
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-num">{{ item.count }}</div>
            <div class="bangzhuang">{{ item.packingMethod || "/" }}</div>
          </div>
        </div>
        <div
          class="accept-more"
          @click="showNum = 100"
          v-if="(showNum == 100 || orderInfo.orderItems.length < 3) == false"
        >
          查看更多
          <svg class="icon iconbiaodan_rili_left" aria-hidden="true">
            <use xlink:href="#iconbiaodan_rili_left" />
          </svg>
        </div>
      </div>
    </div>

    <div class="logistics-info">
      <div class="title-mode accept-title">完工信息</div>
      <div class="xinxi">
        <div class="tabclass">
          <span class="label">完工内容：</span>
          {{
            orderInfo.orderCompleteConfirm &&
            orderInfo.orderCompleteConfirm.content
              ? orderInfo.orderCompleteConfirm.content
              : "/"
          }}
        </div>
        <div
          class="tabclass img-info"
          v-if="
            orderInfo.orderCompleteConfirm &&
              orderInfo.orderCompleteConfirm.imgs
          "
        >
          <span class="label">相关图片：</span>
          <!-- <img v-for="(item, index) in orderInfo.orderCompleteConfirm.imgs" :src="item.url" alt /> -->
          <template
            v-for="(item, index) in orderInfo.orderCompleteConfirm.imgs"
          >
            <el-image
              v-if="imgOrVideo(item.url).type == 'img'"
              :key="index"
              :src="imgOrVideo(item.url).url"
              :preview-src-list="setPreviewList(imgLis)"
            ></el-image>
            <el-image
              style="cursor: pointer"
              v-if="imgOrVideo(item.url).type == 'video'"
              :key="index"
              :src="imgOrVideo(item.url).url"
              @click="openVideo({ installVideoUrl: item.url })"
            ></el-image>
            <audio
              v-if="imgOrVideo(item.url).type == 'audio'"
              controls
              :src="imgOrVideo(item.url).url"
            ></audio>
            <a
              v-if="imgOrVideo(item.url).type == 'download'"
              :href="imgOrVideo(item.url).url"
              target="_blank"
              >媒体下载</a
            >
          </template>
        </div>
      </div>
    </div>

    <div class="logistics-info">
      <div class="title-mode accept-title">师傅信息</div>
      <div class="xinxi">
        <div class="tabclass">
          <span class="label">师傅姓名：</span>
          {{ orderInfo.workerName }}
        </div>
        <div class="tabclass">
          <span class="label">师傅电话：</span>
          {{ orderInfo.workerPhone }}
        </div>
        <div class="tabclass">
          <span class="label">客户姓名：</span>
          {{ orderInfo.customerName }}
        </div>
        <div class="tabclass">
          <span class="label">客户电话：</span>
          {{ orderInfo.customerPhone }}
        </div>
      </div>
    </div>
    <button
      class="btn-accept"
      @click="acceptance = true"
      v-if="orderInfo.status == 'WAIT_ACCEPT' && orderInfo.isAcceptance == null"
    >
      验收
    </button>
    <button
      class="btn-accept"
      disabled
      v-if="
        orderInfo.status == 'WAIT_ACCEPT' && orderInfo.isAcceptance == false
      "
    >
      等待重新完工拍照
    </button>

    <el-dialog title="验收" :visible.sync="acceptance" :before-close="close">
      <div class="accept">
        <el-radio
          class="accept-radio"
          v-model="radio"
          label="1"
          border
          @change="reason = false"
          >验收通过</el-radio
        >
        <el-radio
          class="accept-radio"
          v-model="radio"
          label="2"
          border
          @change="reason = true"
          >验收不通过</el-radio
        >
        <div class="reason" v-if="reason">
          <div class="reason-text"><span>*</span> 验收不通过原因</div>
          <el-input
            class="reason-textarea"
            v-model="input"
            placeholder="请输入内容"
            type="textarea"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="acceptance = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="acceptanceCheck()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import { imgOrVideo } from "@/utils/util";
import videoPlay from "./modules/videoPlay";

export default {
  components: {
    videoPlay,
  },
  data() {
    return {
      acceptance: false,
      radio: "1",
      reason: false,
      input: "",
      orderInfo: {
        orderItems: [],
        orderCompleteConfirm: {
          imgs: [],
        },
      },
      loading: false,
      showNum: 2,
      imgLis: [],
    };
  },
  activated() {
    var _this = this;
    this.$fetch(`/order/api/order/${_this.$route.query.orderid}`).then(
      (res) => {
        if (res.code == 0) {
          this.imgLis = [];
          _this.orderInfo = res.data;
          res.data.orderCompleteConfirm.imgs.map((i) => {
            _this.imgLis.push(i.url);
          });
        } else {
          this.$message(res.message);
        }
      }
    );
  },
  watch: {
    acceptance(val) {
      if (!val) this.close();
    },
  },
  methods: {
    close() {
      this.radio = "1";
      this.input = "";
      this.acceptance = false;
      this.reason = false;
    },
    imgOrVideo,
    setPreviewList(list) {
      return list.map((i) => this.imgOrVideo(i).url);
    },
    // 播放视频
    openVideo(item) {
      this.$refs.videoPlay.init(item);
    },
    acceptanceCheck() {
      let _this = this;
      this.loading = true;
      this.$post(
        `/order/api/order/${_this.$route.query.orderid}/accept?isPass=${
          _this.radio == 1 ? true : false
        }&content=${_this.input}`
      )
        .then((res) => {
          if (res.code == 0) {
            _this.acceptance = false;
            _this.$router.push({
              name: "allOrder",
              params: {
                status: this.radio == 1 ? "WAIT_EVALUATE" : "WAIT_ACCEPT",
              },
            });
            this.$message({
              message: "已提交验收",
              type: "success",
            });
          } else {
            this.$message(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-info {
  // margin-top: 10px;
  .goods {
    background: #fff;
    .goods-tab {
      background: #f9fafa;
      height: 30px;
      font-size: 12px;
      color: #5e6066;
      display: flex;
      div {
        line-height: 31px;
        text-align: center;
      }
      .shang {
        width: 370px;
      }
      .shuliang {
        width: 300px;
      }
      .baozhuang {
        width: 187px;
      }
    }
    .goods-list {
      // margin-top: 10px;
      padding: 10px 20px;
      .item-goods {
        display: flex;
        font-size: 12px;
        color: #2f3133;
        margin-bottom: 10px;
        div {
          display: flex;
          align-items: center;
        }
        img {
          width: 50px;
          height: 50px;
          margin-right: 12px;
        }
        .goods-name {
          width: 310px;
          height: 50px;
        }
        .goods-num {
          width: 300px;
          justify-content: center;
        }
        .bangzhuang {
          width: 187px;
          justify-content: center;
        }
      }
      .item-goods:hover {
        background: #f9fafa;
        cursor: pointer;
      }
    }
    .goods-basic-info {
      padding: 0 20px;
      display: flex;
      font-size: 12px;
      .tabclass {
        margin-right: 60px;
        color: #2f3133;
        .label {
          color: #5e6066;
          margin-right: 10px;
        }
      }
    }

    .markup {
      padding: 0 20px;
      margin-top: 20px;
      font-size: 12px;
      color: #5e6066;
      .markup-item {
        color: #2f3133;
        margin-bottom: 5px;
        span {
          margin-right: 45px;
        }
      }
      .markup-item:nth-child(1) {
        margin-top: 3px;
      }
      .markup-item:last-child {
        margin-bottom: 0;
      }
    }
    .step_one_price {
      margin-top: 10px;
      padding: 0 20px 37px 20px;
      font-size: 12px;
      color: #2f3133;
      margin-bottom: 0;
      .one_tab {
        align-items: flex-end;
      }
      .one_total {
        font-size: 26px;
        height: 26px;
      }
    }
  }
}
</style>
<style lang="scss">
.acceptance {
  .reason-textarea {
    textarea {
      border-radius: 2px;
      height: 170px;
      resize: none;
      margin-top: 15px;
    }
    textarea:hover,
    textarea:focus {
      border-color: #3455d3;
    }
  }
  .reason {
    margin-top: 24px;
    .reason-text {
      color: #5e6066;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      span {
        color: #f75658;
      }
    }
  }
  .goods-info {
    .goods {
      padding-bottom: 20px;
      .goods-tab {
        background: #f9fafa !important;
      }
      .accept-more {
        color: #5e6066;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .iconbiaodan_rili_left {
          width: 12px;
          height: 12px;
          transform: rotate(270deg);
          margin-left: 5px;
        }
      }
    }
  }
  .title-accept {
    font-weight: bold;
    font-size: 16px;
    border-bottom: none;
    margin-bottom: 10px;
  }
  .accept-title {
    font-weight: bold;
    border-bottom: none;
    font-size: 16px;
  }
  .btn-accept {
    width: 190px;
    height: 46px;
    background: rgba(52, 85, 211, 1);
    border-radius: 2px;
    text-align: center;
    font-size: 20px;
    line-height: 46px;
    border: none;
    color: #fff;
    outline: none;
    cursor: pointer;
    margin: 24px 0 100px 0;
    float: right;
  }
  .logistics-info,
  .goods-info {
    margin-top: 15px;
  }
  .title-mode {
    height: 46px;
  }
  .xinxi {
    padding: 18px 20px 8px 20px;
    .tabclass {
      margin-bottom: 14px;
    }
  }
  .accept-radio {
    display: block;
    height: 40px;
    color: #909399;
    font-size: 14px;
    margin-left: 0px !important;
    margin-top: 10px;
  }
  .accept-radio.is-bordered + .accept-radio.is-bordered {
    margin-left: 0 !important;
  }
  .accept-radio:last-child {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss" scoped>
.logistics-info {
  &/deep/ .el-image {
    width: 83px;
    height: 83px;
    margin-right: 8px;

    &:nth-child(8n) {
      margin-right: 0;
    }
    & > img {
      width: 83px;
      height: 83px;
      border-radius: 2px;
      margin-bottom: 8px;
      object-fit: cover;
    }
    .el-image-viewer__canvas {
      img {
        width: auto !important;
      }
    }
  }
}
</style>
